import LogoBank from '@pretto/bricks/components/images/LogoBank'
import { breakpoints, g } from '@pretto/bricks/components/layout'
import { Wrapper } from '@pretto/bricks/components/layout/Wrapper/styles'
import BaseTypo from '@pretto/bricks/components/typography/BaseTypo'
import MiniSentences from '@pretto/bricks/website/shared/components/MiniSentences'

import loadable from '@loadable/component'
import styled from 'styled-components'

const ReasonToBelieveComponent = loadable(
  () => import('@pretto/zen/seo/reasonToBelieve/ReasonToBelieve/ReasonToBelieve'),
  {
    resolveComponent: components => components.ReasonToBelieve,
  }
)

export const SimulationBank = styled(Wrapper)`
  @media screen and (min-width: ${breakpoints.tablet}) {
    color: ${({ theme }) => theme.colors.white};
  }
`
export const BankContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: ${breakpoints.tablet}) {
    grid-column-start: 2;
    grid-row-start: 1;
    justify-content: initial;
  }
`
export const Bank = styled(LogoBank)`
  display: block;
`
export const Title = styled(BaseTypo).attrs({ forwardedAs: 'h1', typo: 'heading48' })`
  margin-bottom: ${g(3)};

  @media screen and (min-width: ${breakpoints.tablet}) {
    grid-column-start: 2;
    margin-bottom: 0;
  }
`
export const Headline = styled.div`
  margin-bottom: ${g(3)};

  @media screen and (min-width: ${breakpoints.tablet}) {
    grid-column-start: 2;
    margin-bottom: 0;
  }
`
export const HeaderTop = styled.header`
  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: ${g(6)} 0 ${g(4)};
    background-color: ${({ theme }) => theme.colors.primary1};
    border-radius: ${g(1)};
    display: grid;
    grid-template-columns: 0 1fr 1fr 0;
    grid-template-rows: auto auto 1fr;
    grid-gap: ${g(3)};
  }
  @media screen and (min-width: ${breakpoints.laptop}) {
    border-radius: ${({ $hasReasonToBelieve }) => ($hasReasonToBelieve ? `${g(1)} ${g(1)} 0 0` : `${g(1)}`)};
    grid-template-columns: 1fr 5fr 5fr 1fr;
  }
`
export const Widget = styled(MiniSentences)`
  margin-bottom: ${g(3)};

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0;
    grid-column: 3 / span 1;
    grid-row: 1 / -1;
    align-self: start;
  }
`
export const ReasonToBelieveList = styled.aside`
  display: flex;
  flex-direction: column;
  margin-top: ${g(5)};
  background-color: ${({ theme }) => theme.colors.white};

  @media screen and (min-width: ${breakpoints.laptop}) {
    flex-direction: row;
    margin-top: 0;
    padding: ${g(2)} ${g(5)};
    background-color: ${({ theme }) => theme.colors.neutral4};
    justify-content: space-evenly;
    align-items: center;
    border-radius: 0 0 ${g(1)} ${g(1)};
  }
`
export const ReasonToBelieve = styled(ReasonToBelieveComponent)`
  display: flex;
  align-items: center;

  & + & {
    margin-top: ${g(3)};

    @media screen and (min-width: ${breakpoints.laptop}) {
      margin-top: 0;
    }
  }
`
